export default {
	start: {
		title: "AI Platform",
		tips: "Görgetésből kereset! Napi kifizetés egy koppintással – A telefonod a pénzgyárod!"
	},
	login: {
		tips: "Nincs fiókod?",
		Signup: "Regisztrálj",
		logIn: "Bejelentkezés",
		Remember: "Emlékezz rám",
		form: {
			label: ["Felhasználónév/Telefon", "Jelszó"]
		},
		forgotPassword: "Elfelejtett jelszó?",
		contactSupport: "Ügyfélszolgálat",
		title: "Fiók létrehozása",
		content: ["Szükséged van fiókra?", "Hozz létre egyet itt"]
	},
	register: {
		form: {
			label: [
				"Felhasználónév",
				"Telefon",
				"Tranzakciós jelszó",
				"Bejelentkezési jelszó",
				"Bejelentkezési jelszó megerősítése",
				"Nem",
				"Meghívókód",
				"E-mail",
				"Ellenőrző kód"
			],
			rule: {
				Username: "A felhasználónévnek 4-10 karakter hosszúnak kell lennie",
				Email: "Kérjük, adjon meg egy érvényes e-mail címet",
				Phone: "A telefonszámnak legalább 4 számjegyből kell állnia",
				ConfirmLoginPassword: "A jelszavak nem egyeznek",
				TradingPassword: "A tranzakciós jelszónak legalább 6 számjegyből kell állnia",
				LoginPassword: "A bejelentkezési jelszónak legalább 6 számjegyből kell állnia"
			}
		},
		sendMsg: "A kódot elküldtük! Kérlek, ellenőrizd az üzeneteid.",
		agree: ["Egyetértek a(z) {0} dokumentummal", "Adatvédelmi nyilatkozat, MSA", "és a", "Felhasználási feltételek"],
		content: [
			"Hozd létre ingyenes fiókodat",
			"Már van fiókod?",
			"Jelentkezz be itt",
			"Fiók létrehozása",
			"A folytatással elfogadod a"
		]
	}
};
